import {requestHost} from './client';
type CookieOptions={name:string;value:string;expires?:Date;maxAge?:number;domain?:string;path?:string;secure?:boolean;httpOnly?:boolean;sameSite?:'lax'|'none'|'strict';priority?:'low'|'medium'|'high'};
export async function getCookie(name:string):Promise<string|null>{
  const result=await requestHost({method:'GET',path:'/__platform/preferences',params:{name}});
  if(result===null||typeof result==='string')return result;
  throw new Error('와카 설정 응답을 확인하지 못했습니다.');
}
export async function createCookie(props:CookieOptions){await requestHost({method:'POST',path:'/__platform/preferences',body:props});}
export async function deleteCookie(name:string){await requestHost({method:'DELETE',path:'/__platform/preferences',body:{name}});}
export async function getAllCookies():Promise<Array<{name:string;value:string}>>{
  throw new Error('편집기에 전체 쿠키를 전달하지 않습니다.');
}
export async function createTokenCookie(_props:Pick<CookieOptions,'name'|'value'|'maxAge'>){
  throw new Error('회사 서비스 계정 대신 와카 로그인 연결을 사용합니다.');
}
